module.exports = __webpack_public_path__ + "media/main-ui-flip.395d255a.wav";